import { SET_IDXDB_LOADING, SET_IDXDB_ERROR, SET_IDXDB_VALIDATIONS } from "./actionTypes";

export function setDataLoading() {
  return {
    type: SET_IDXDB_LOADING,
  };
}

export function setDataError(error) {
  return {
    type: SET_IDXDB_ERROR,
    error: error,
  };
}

export function setUpdatingValidations() {
  return {
    type: SET_IDXDB_VALIDATIONS,
  };
}
